import { render, staticRenderFns } from "./ButtonSetPassword.vue?vue&type=template&id=4081487e&scoped=true&"
import script from "./ButtonSetPassword.vue?vue&type=script&lang=js&"
export * from "./ButtonSetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4081487e",
  null
  
)

export default component.exports